export default {
  sections: {
    payment: 'Paiement',
  },
  labels: {
    proceed_to_payment: 'Procéder au paiement via le lien ou scanner le QR code',
  },
  buttons: {
    generate_new_link: 'Générer un nouveau lien',
    copy_link: 'Copier le lien',
    pay_now: 'Payer maintenant',
  },
  toasts: {
    failed_to_create_payment_link: 'Impossible de charger le lien de paiement',
  },
};
